__turbopack_context__.v({
  "active": "text-field-module-scss-module__5WyOra__active",
  "box": "text-field-module-scss-module__5WyOra__box",
  "box__has-focus": "text-field-module-scss-module__5WyOra__box__has-focus",
  "dense": "text-field-module-scss-module__5WyOra__dense",
  "disabled": "text-field-module-scss-module__5WyOra__disabled",
  "end-icon": "text-field-module-scss-module__5WyOra__end-icon",
  "error": "text-field-module-scss-module__5WyOra__error",
  "fullWidth": "text-field-module-scss-module__5WyOra__fullWidth",
  "has-label": "text-field-module-scss-module__5WyOra__has-label",
  "helper-text": "text-field-module-scss-module__5WyOra__helper-text",
  "input": "text-field-module-scss-module__5WyOra__input",
  "label": "text-field-module-scss-module__5WyOra__label",
  "ltr": "text-field-module-scss-module__5WyOra__ltr",
  "no-border-bottom": "text-field-module-scss-module__5WyOra__no-border-bottom",
  "no-border-end": "text-field-module-scss-module__5WyOra__no-border-end",
  "no-border-start": "text-field-module-scss-module__5WyOra__no-border-start",
  "no-border-top": "text-field-module-scss-module__5WyOra__no-border-top",
  "no-resize": "text-field-module-scss-module__5WyOra__no-resize",
  "prefix": "text-field-module-scss-module__5WyOra__prefix",
  "rtl": "text-field-module-scss-module__5WyOra__rtl",
  "start-icon": "text-field-module-scss-module__5WyOra__start-icon",
  "suffix": "text-field-module-scss-module__5WyOra__suffix",
  "text-field": "text-field-module-scss-module__5WyOra__text-field",
});
